import React, { useMemo } from 'react';
import CourseOfferCard, { LockedCourseCard } from './CourseOfferCard';
import { catalogCourseEntries } from '../content/academyCourses';

export default function CoursesCatalogPage({
  catalog,
  onBack,
  onOpenCourse,
}) {
  const courses = useMemo(() => catalogCourseEntries(catalog), [catalog]);

  return (
    <div className="gl-courses-page">
      <header className="gl-courses-page-nav">
        <a className="gl-brand" href="#top" onClick={(e) => { e.preventDefault(); onBack(); }}>
          <img src="/phone/gl-logo.png" alt="" className="gl-brand-mark" />
          <span>Great Leaders</span>
        </a>
        <button type="button" className="gl-courses-back" onClick={onBack}>
          חזרה לעמוד הראשי
        </button>
      </header>

      <main className="gl-courses-page-main">
        <div className="gl-courses-page-hero">
          <p className="gl-kicker">{catalog.kicker}</p>
          <h1>{catalog.pageTitle}</h1>
          <p className="gl-courses-page-lead">{catalog.pageLead}</p>
        </div>

        <div className="gl-offer-grid gl-courses-grid">
          {courses.map(({ course, locked }, index) => (
            locked ? (
              <LockedCourseCard key={course.id} course={course} index={index} />
            ) : (
              <CourseOfferCard
                key={course.id}
                course={course}
                index={index}
                onOpen={onOpenCourse}
              />
            )
          ))}
        </div>
      </main>
    </div>
  );
}
